// Auto-split from i18n.js — language: jp
export default {
    translation: {
        // routes & menus
        Dashboard: '総覧',
        'Space Data': '空間データ',
        'Equipment Data': '設備データ',
        'Meter Data': '計量メータデータ',
        'Tenant Data': 'テナントデータ',
        'Store Data': '店舗データ',
        'Shopfloor Data': '現場データ',
        'Combined Equipment Data': '複合設備データ',
        'Auxiliary System': '補助システム',
        Microgrid: 'マイクログリッド',
        'Energy Storage Power Station': '発電所',
        'Photovoltaic Power Station': '発電所',
        'Fault Alarm': '故障アラーム',
        Monitoring: '設備監視',
        'Advanced Reporting': '高度レポート',
        'Knowledge Base': 'ナレッジベース',
        'Energy Category Data': 'エネルギー分類分析',
        'Energy Item Data': 'エネルギー項目分析',
        Carbon: '炭素排出分析',
        Cost: 'コスト分析',
        Output: '産出分析',
        Income: '収入分析',
        Efficiency: '効率分析',
        Load: '負荷分析',
        Statistics: '統計分析',
        'Batch Analysis': '一括分析',
        Saving: '省エネ分析Ⓔ',
        Plan: '計画分析Ⓔ',
        Prediction: '予測分析Ⓔ',
        'Production': '生産量',
        'Space Production': '生産量エネルギー分析',
        'Equipment Tracking': '設備台帳',
        'Equipment Comparison': '比較分析',
        'Shopfloor Comparison': '比較分析',
        'Store Comparison': '比較分析',
        'Space Comparison': '比較分析',
        'Combined Equipment Comparison': '比較分析',
        'Tenant Comparison': '比較分析',
        'Environment Monitor': '環境モニタリング',
        'Meter Energy': '計量メータエネルギー分析',
        'Meter Prediction': 'メーター予測Ⓔ',
        'Virtual Meter Prediction': '仮想メーター予測Ⓔ',
        'Offline Meter Prediction': 'オフラインメーター予測Ⓔ',
        'Meter Carbon': '計量メータ炭素排出分析',
        'Meter Cost': '計量メータコスト分析',
        'Meter Trend': '計量メータ傾向分析',
        'Meter Realtime': '計量メータリアルタイム分析',
        'Meter Saving': '計量メータ省エネ分析Ⓔ',
        'Meter Plan': '計量メータ計画分析Ⓔ',
        'Master Meter Submeters Balance': '総メータサブメータ平衡分析',
        'Meter Batch Analysis': '計量メータ一括分析',
        'Meter Comparison': '計量メータ比較分析',
        'Meter Tracking': '計量メータ台帳',
        'Virtual Meter Saving': '仮想メータ省エネ分析Ⓔ',
        'Virtual Meter Plan': '仮想メータ計画分析Ⓔ',
        'Virtual Meter Energy': '仮想メータエネルギー分析',
        'Virtual Meter Carbon': '仮想メータ炭素排出分析',
        'Virtual Meter Cost': '仮想メータコスト分析',
        'Virtual Meter Batch Analysis': '仮想メータ一括分析',
        'Virtual Meter Comparison': '仮想メータ比較分析',
        'Offline Meter Energy': 'オフラインメータエネルギー分析',
        'Offline Meter Carbon': 'オフラインメータ炭素排出分析',
        'Offline Meter Cost': 'オフラインメータコスト分析',
        'Offline Meter Batch Analysis': 'オフラインメータ一括分析',
        'Offline Meter Saving': 'オフラインメータ省エネ分析Ⓔ',
        'Offline Meter Plan': 'オフラインメータ計画分析Ⓔ',
        'Offline Meter Input': 'オフラインメータデータ入力',
        'Tenant Bill': 'テナント請求書',
        'Energy Flow Diagram': 'エネルギー流れ図',
        'Distribution System': '配電システム',
        'SVG System': 'コンフィギュレーション可視化システム',
        'Faults Data': '故障分析',
        'Space Equipments': '空間設備',
        'Combined Equipments': '複合設備',
        'Energy Storage Power Station List': '発電所リスト',
        'Energy Storage Power Station Details': '設備監視',
        'Energy Storage Power Station Reporting': 'データレポート',
        'Energy Storage Power Station Alarm': '故障アラーム',
        'Energy Storage Power Station Maintenance': 'メンテナンス',
        'Enter Production': '生産量入力',
        'Multiple Microgrids': '多サイトデータ',
        'Multiple Microgrids Dashboard': '多サイト総覧',
        'Multiple Microgrids List': '発電所リスト',
        'Single Microgrid': '単一サイトデータ',
        'Single Microgrid Dashboard': '単一サイト総覧',
        'Single Microgrid Details': '設備データ',
        'Single Microgrid Fault Alarm': '故障警告',
        'Microgrid Reports': '統計レポート',
        'Microgrid Reports Energy': '電力量レポート',
        'Microgrid Reports Revenue': '収益レポート',
        'Microgrid Reports Parameters': 'データクエリ',
        'Multiple Energy Storage Power Stations': 'エネルギー貯蔵多サイトデータ',
        'Multiple Energy Storage Power Stations Dashboard': 'エネルギー貯蔵多サイト総覧',
        'Multiple Energy Storage Power Stations List': 'エネルギー貯蔵発電所リスト',
        'Single Energy Storage Power Station': 'エネルギー貯蔵単一サイトデータ',
        'Single Energy Storage Power Station Dashboard': 'エネルギー貯蔵単一サイト総覧',
        'Single Energy Storage Power Station Details': 'エネルギー貯蔵設備データ',
        'Single Energy Storage Power Station Fault Alarm': 'エネルギー貯蔵故障警告',
        'Energy Storage Power Station Reports': 'エネルギー貯蔵統計レポート',
        'Energy Storage Power Station Reports Energy': 'エネルギー貯蔵電力量レポート',
        'Energy Storage Power Station Reports Revenue': 'エネルギー貯蔵収益レポート',
        'Energy Storage Power Station Reports Parameters': 'エネルギー貯蔵データクエリ',
        'Photovoltaic Power Station List': '発電所リスト',
        'Photovoltaic Power Station Details': '設備監視',
        'Photovoltaic Power Station Reporting': 'データレポート',
        'Photovoltaic Power Station Alarm': '故障アラーム',
        'Photovoltaic Power Station Maintenance': 'メンテナンス',
        'Multiple Photovoltaic Power Stations': '多サイトデータ',
        'Multiple Photovoltaic Power Stations Dashboard': '多サイト総覧',
        'Multiple Photovoltaic Power Stations List': '発電所リスト',
        'Single Photovoltaic Power Station': '単一サイトデータ',
        'Single Photovoltaic Power Station Dashboard': '単一サイト総覧',
        'Single Photovoltaic Power Station Details': '設備データ',
        'Single Photovoltaic Power Station Fault Alarm': '故障警告',
        'Photovoltaic Power Station Reports': '統計レポート',
        'Photovoltaic Power Station Reports Energy': '電力量レポート',
        'Photovoltaic Power Station Reports Revenue': '収益レポート',
        'Photovoltaic Power Station Reports Parameters': 'データクエリ',
        'Work Order': '作業票管理',
        'Work Order Installation': '設置記録',
        'Work Order Repair': '修理記録',
        'Work Order Inspection': '巡回点検記録',
        'Total Number of Work Orders': '総作業票数量',
        'Number of New Work Orders': '新規発行作業票数量',
        'Number of Inprogress Work Orders': '進行中作業票数量',
        'Number of Done Work Orders': '完了済み作業票数量',
        'Fuel Indicator': '燃料消費量',
        'Charge Energy Indicator': '充電エネルギー',
        'Discharge Energy Indicator': '放電エネルギー',
        'Charge Cost Indicator': '充電コスト',
        'Discharge Revenue Indicator': '放電収益',
        'HVAC': '空調',
        'Fire Control': '消防',
        'Store Dashboard': 'ストアダッシュボード',
        'Comprehensive overview of store energy performance': 'ストアエネルギーパフォーマンスの総合概要',
        'Total Stores': 'ストア総数',
        'Total Area': '総面積',
        'Active Meters': '稼働中メーター',
        'Active Alerts': 'アクティブアラート',
        'Total Energy Consumption': '総エネルギー消費量',
        'Carbon Emissions': '炭素排出量',
        'Current Period': '当期',
        'Energy Consumption by Category': 'カテゴリ別エネルギー消費',
        'Cost Distribution by Category': 'カテゴリ別コスト分布',
        'Monthly Energy & Cost Trends': '月次エネルギー・コストトレンド',
        'Top 5 Energy Consuming Stores': 'エネルギー消費トップ5ストア',
        'Energy Category Details': 'エネルギーカテゴリ詳細',
        'Store Performance Overview': 'ストアパフォーマンス概要',
        'YoY Change': '前年比',
        'Per m²': '平米あたり',
        'Usage Intensity': '使用強度',
        'Dashboard data loaded successfully': 'ダッシュボードデータの読み込みが完了しました',
        'Failed to load dashboard data': 'ダッシュボードデータの読み込みに失敗しました',
        'Store Name': '店舗名',
        'Store Area': '店舗面積',
        'Energy Consumption': 'エネルギー消費量',
        'Consumption': '消費量',
        'last period': '前期',
        // Tenant Dashboard
        'Tenant Dashboard': 'テナントダッシュボード',
        'Comprehensive overview of tenant energy performance': 'テナントのエネルギーパフォーマンスの包括的な概要',
        'Total Tenants': 'テナント総数',
        'Tenant Performance Overview': 'テナントパフォーマンス概要',
        'Tenant Name': 'テナント名',
        'Tenant Area': 'テナント面積',
        'Tenant Type': 'テナントタイプ',
        // Equipment Dashboard
        'Equipment Dashboard': '設備ダッシュボード',
        'Total Equipments': '設備総数',
        'Equipment Performance Overview': '設備パフォーマンス概要',
        'Equipment Name': '設備名',
        'Equipment Type': '設備タイプ',
        'Total Energy': '総エネルギー',
        'Total Sensors': 'センサー総数',
        'Increment Rate': '増加率',
        // Shopfloor Dashboard
        'Total Shopfloors': '车间総数',
        'Shopfloor Performance Overview': '车间パフォーマンス概要',
        'Shopfloor Name': '车间名',
        'Shopfloor Area': '车间面積',
        // Combined Equipment Dashboard
        'Total Combined Equipments': '複合設備総数',
        'Combined Equipment Performance Overview': '複合設備パフォーマンス概要',
        'Combined Equipment Name': '複合設備名',
        'Associated Equipments': '関連設備数',

            // Dashboard
            'Welcome to QiXuan': 'QiXuanへようこそ',
            'An Industry Leading Energy Management System': '業界をリードするエネルギー管理システム',
            "This Year's Consumption CATEGORY VALUE UNIT": '本年消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": '本年コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": '今月消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": '今月産出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Costs CATEGORY VALUE UNIT": '今月コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': '前年同期消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '前年同期コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} 消費 {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} コスト {{UNIT}}',
            // Entities
            Space: '空間',
            Equipment: '設備',
            Meter: '計量メータ',
            'Offline Meter': 'オフラインメータ',
            'Virtual Meter': '仮想メータ',
            Tenant: 'テナント',
            Store: '店舗',
            Shopfloor: '現場',
            'Combined Equipment': '複合設備',
            'Cost Center': 'コストセンター',
            Name: '名称',
            DisplayName: '表示名',
            UserName: 'ユーザー名',
            Description: '説明',
            'Energy Category': 'エネルギー分類',
            'Child Spaces': '子空間',
            'Associated Equipment': '関連設備',
            //Energy Categories
            Electricity: '電気',
            Water: '水道水',
            'Natural Gas': '天然ガス',
            // SidePanelModal
            Settings: '設定',
            'Set your own customized style': 'カスタマイズしたスタイルを設定する',
            'Color Scheme': 'カラースキーム',
            'Choose the perfect color mode for your app': 'アプリに最適なカラーモードを選択',
            Light: 'ライト',
            Dark: 'ダーク',
            'RTL Mode': 'RTLモード',
            'Switch your language direction': '言語の方向を切り替える',
            'Fluid Layout': '流動レイアウト',
            'Toggle container layout system': 'コンテナレイアウトシステムを切り替える',
            'Navigation Position': 'ナビゲーションバー位置',
            'Vertical': '垂直',
            'Top': '上部',
            'Combo': 'コンボ',
            'Transparent': '透明',
            'Inverted': '反転色',
            'Card': 'カード',
            'Vibrant': '鮮やか',
            'Select a suitable navigation system for your web application': 'Webアプリケーションに適したナビゲーションバーシステムを選択',
            'Vertical Nav': '垂直ナビゲーションバー',
            'Top Nav': '上部ナビゲーションバー',
            'Vertical Navbar Style': '垂直ナビゲーションバースタイル',
            'Switch between styles for your vertical navbar': '垂直ナビゲーションバーのスタイルを切り替える',
            Language: '言語',
            'Switch between languages': '言語を切り替える',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'このシステムが気に入りましたか？',
            'Get QiXuan now': 'QiXuanを今すぐ入手',
            'PQ.About': '本分析は電圧偏差、電圧不平衡、周波数偏差、電流不平衡を対象とします。電圧偏差は(U−Un)/Un×100%で計算されます。周波数偏差は|f−fn|で計算されます。三相不平衡はmax(|Xi−Xavg|)/Xavg×100%で計算され、三相チャネルのタイムアライメントが要求されます。結果は、選択された計量メータの報告期間内の時系列データに基づきます。三相チャネルが不足している場合やタイムスタンプが同期していない場合は、不平衡指標がスキップされます。過渡的なスパイクやサンプリング欠落は最悪値を増幅する可能性があり、定常状態の評価にはコンプライアンス率やP95などの統計指標を参照することをお勧めします。',
            Purchase: 'エンタープライズ版を購入',
            ContactInfo: '連絡先情報',
            ProductWebsite: '製品サイト',
            CompanyWebsite: '会社サイト',
            SalesPhone: '営業電話',
            // Query Panels
            'Base Period Begins': '基準期間開始',
            'Base Period Ends': '基準期間終了',
            'Comparison Types': '比較タイプ',
            'Year-Over-Year': '前年比',
            'Month-On-Month': '前月比',
            'Free Comparison': '自由比較',
            'None Comparison': '比較なし',
            'Reporting Period Begins': '報告期間開始',
            'Reporting Period Ends': '報告期間終了',
            '(Optional)': '(オプション)',
            'Period Types': '時間尺度',
            Yearly: '年',
            Monthly: '月',
            Weekly: '週',
            Daily: '日',
            Hourly: '時間',
            Submit: '送信',
            'Input Energy Category': '消費エネルギー分類',
            'Output Energy Category': '産出エネルギー分類',
            'Fraction Parameter': '分数パラメータ',
            Search: '検索',
            //DateRangePicker
            sunday: '日',
            monday: '月',
            tuesday: '火',
            wednesday: '水',
            thursday: '木',
            friday: '金',
            saturday: '土',
            ok: '確定',
            today: '今日',
            yesterday: '昨日',
            hours: '時',
            minutes: '分',
            seconds: '秒',
            last7Days: '過去7日間',
            tomorrow: '明日',
            dayAfterTomorrow: '明後日',
            next7Days: '今後7日間',
            'Select Date Range': '日付範囲を選択',
            //Card Summaries and Line Charts
            'Base Period': '基準期間',
            'Reporting Period': '報告期間',
            'Per Unit Area': '単位面積あたり',
            'Per Capita': '一人あたり',
            'Per Unit Production': '単位製品あたり',
            Baseline: 'ベースライン値',
            Actual: '実績値',
            'Baseline Value - Actual Value': 'ベースライン値 - 実績値',
            'Average Load': '平均負荷',
            'Maximum Load': '最大負荷',
            'Load Factor': '負荷率',
            'Ratio of Average Load to Maximum Load': '平均負荷と最大負荷の比率',
            'Carbon Dioxide Emissions by Energy Category': '二酸化炭素排出割合',
            'Costs by Energy Category': 'コスト割合',
            'Incomes by Energy Category': '収入割合',
            'Electricity Consumption by Time-Of-Use': '時間帯別消費電力量',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': '時間帯別電力使用による二酸化炭素排出',
            'Electricity Cost by Time-Of-Use': '時間帯別電力コスト',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} 項目別消費割合',
            'Ton of Standard Coal by Energy Category': 'トン標準炭(TCE)割合',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'トン二酸化炭素排出(TCO2E)割合',
            'Reporting Period Consumption CATEGORY UNIT': '報告期間消費 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': '報告期間予測 {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} 報告期間消費 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間消費 {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': '報告期間生産量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': '基準期間生産量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': '報告期間消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': '報告期間予測 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': '基準期間消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': '報告期間予測 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': '報告期間消費 {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '報告期間消費 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': '基準期間消費 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': '子空間分類割合 {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': '子空間合計割合',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '報告期間二酸化炭素排出 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                '報告期間二酸化炭素排出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '基準期間二酸化炭素排出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': '報告期間コスト {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': '報告期間コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': '基準期間コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': '報告期間産出 {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} 報告期間産出 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間産出 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': '報告期間産出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': '基準期間産出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': '報告期間収入 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': '報告期間収入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': '基準期間収入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': '報告期間総収入 {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': '報告期間累積効率 {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} 報告期間累積効率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間累積総合効率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間累積総合効率 {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 基準期間累積総合効率 {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': '瞬時効率 {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 瞬時効率 {{UNIT}}',
            'Equipment Efficiency Indicator': '設備エネルギー効率指標',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 瞬時総合効率 {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': '報告期間累積効率 {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '報告期間累積効率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': '基準期間累積効率 {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': '基準期間累積効率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': '基準期間 {{CATEGORY}} 最大負荷 {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': '報告期間 {{CATEGORY}} 最大負荷 {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': '報告期間 {{CATEGORY}} 平均負荷 {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': '報告期間 {{CATEGORY}} 負荷率',
            'Base Period CATEGORY Average Load VALUE UNIT': '基準期間 {{CATEGORY}} 平均負荷 {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': '報告期間 {{CATEGORY}} 平均値 {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': '報告期間 {{CATEGORY}} 最大値 {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': '報告期間 {{CATEGORY}} 最小値 {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': '報告期間 {{CATEGORY}} 算術平均 {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': '報告期間 {{CATEGORY}} 中央値 {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': '報告期間 {{CATEGORY}} 標本標準偏差 {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': '報告期間 {{CATEGORY}} 標本分散 {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '報告期間節約 {{CATEGORY}} (ベースライン-実績) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '報告期間減少 {{CATEGORY}} (ベースライン-実績) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': '報告期間節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': '基準期間節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': '報告期間総メータ消費 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '報告期間総メータ消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': '報告期間サブメータ消費 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': '報告期間サブメータ消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': '報告期間差 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': '報告期間差百分比',
            'Reporting Period Difference CATEGORY VALUE UNIT': '報告期間差 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': '傾向値',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': '故障リスト',
            'Reporting Period Number of Fault VALUE': '報告期間故障数: {{VALUE}}',
            'All Faults': '全故障',
            'Space Faults': '空間故障',
            'Number of All Faults': '全故障数',
            'Number of Space Faults': '空間故障数',
            'Total Number of Faults': '総故障数量',
            'Number of New Faults': '新規故障数量',
            'Number of Inprogress Faults': '進行中故障数量',
            'Number of Done Faults': '完了済み故障数量',
            //Data Panels
            'Ton of Standard Coal': 'トン標準炭',
            'Ton of Carbon Dioxide Emissions': 'トン二酸化炭素排出',
            'Carbon Emissions Per Unit Of Energy Consumption': '単位エネルギー消費当たり炭素排出',
            'Operating Characteristic Curve': '運転曲線',
            Tariff: '料率',
            'Detailed Data': '詳細データ',
            'Child Spaces Data': '子空間データ',
            'Associated Equipment Data': '関連設備データ',
            'This Year': '本年',
            'The Same Period Last Year': '前年同期',
            'This Month': '今月',
            'This Day': '本日',
            Total: '合計',
            'No data found': 'データがありません',
            Export: 'エクスポート',
            'AI Analysis': 'AI分析',
            Datetime: '日時',
            'Time-Of-Use Type': '時間帯タイプ',
            'Top-Peak': 'ピーク',
            'On-Peak': 'オン・ピーク',
            'Mid-Peak': 'ミッド・ピーク',
            'Off-Peak': 'オフ・ピーク',
            'Deep': '深夜',
            Percentage: '百分比',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'エネルギー値ポイントの過去1時間傾向',
            Circuit: '回路',
            Point: 'データポイント',
            'Realtime Value': 'リアルタイム値',
            //Meter Tracking
            'Meter List': '計量メータリスト',
            'Edit Meter': '編集',
            'Start Value': '開始値',
            'End Value': '終了値',
            'Difference Value': '差額',
            'Start Integrity Rate': '開始データ完全性率(%)',
            'End Integrity Rate': '終了データ完全性率(%)',
            'Full Integrity Rate': '全体データ完全性率(%)',
            'Start Integrity Rate Description': '開始データ完全率：統計期間内に、すべてのメーターのうち、開始時刻のエネルギー消費量読み取りに成功したメーターの割合',
            'End Integrity Rate Description': '終了データ完全率：統計期間内に、すべてのメーターのうち、終了時刻のエネルギー消費量読み取りに成功したメーターの割合',
            'Full Integrity Rate Description': '全量データ完全率：統計期間内に、すべてのメーターのうち、開始時刻と終了時刻の両方のエネルギー消費量読み取りに成功したメーターの割合',
            //Equipment Tracking
            'Equipment List': '設備リスト',
            'Edit Equipment': '編集',
            //Profile Dropdown
            Feedback: 'フィードバック',
            'Account Settings': 'アカウント設定',
            Logout: 'ログアウト',
            //Authentication
            'Log in': 'ログイン',
            'Email address': '電子メールアドレス',
            'Phone Number': '電話番号',
            Password: 'パスワード',
            CaptchaCode: '認証コード',
            Refresh: '更新',
            'Remember me': 'ログイン状態を保持',
            'Logged in as ': 'ログイン済み ',
            'Forgot Password?': 'パスワードをお忘れですか？',
            'Forgot your password?': 'パスワードをお忘れですか？',
            "Enter your email and we'll send you a reset link": '電子メールアドレスを入力すると、リセットリンクを送信します',
            "Enter your email and we'll send you a registration link": '電子メールアドレスを入力すると、登録リンクを送信します',
            'Reset Password': 'パスワードリセット',
            'Thanks for using QiXuan!': 'QiXuanをご利用いただきありがとうございます！',
            'You are now successfully signed out': '正常にログアウトしました',
            'Return to Login': 'ログイン画面に戻る',
            'Please check your email!': '電子メールを確認してください！',
            'An email has been sent to ': '電子メールが送信されました ',
            'Please click on the included link to reset your password': '含まれるリンクをクリックしてパスワードをリセットしてください',
            'Please click on the included link to register your account': '含まれるリンクをクリックしてアカウントを登録してください',
            'An email with password reset link is sent to ': 'パスワードリセットリンク付きの電子メールが送信されました ',
            'Change Password': 'パスワード変更',
            'Old Password': '旧パスワード',
            'New Password': '新パスワード',
            'Confirm Password': '新パスワード確認',
            'Update Password': 'パスワード更新',
            'Password has been changed!': 'パスワードが変更されました！',
            'Verification code has been sent to your inbox. \
            Please copy it to the input box below.':
                '認証コードが受信箱に送信されました。下記の入力ボックスにコピーしてください。',
            'New to QiXuan': 'QiXuanを初めてお使いの方',
            'Create an account': 'アカウント登録',
            'EMAIL Account registration successful': '{{EMAIL}}アカウント登録成功',
            'Thanks for verifying your account!': 'アカウントの認証ありがとうございます！',
            'Your code is': 'コードは次のとおりです',
            'Send verification code': '認証コードを送信',
            'Please wait for NUMBER seconds': '{{NUMBER}}秒お待ちください',
            'Password reset': 'パスワードリセット',
            'Please wait for approval': '承認をお待ちください',
            //notification
            Notifications: '通知',
            'Mark all as read': 'すべて既読にする',
            'View all': 'すべて表示',
            'Notification New': '新着',
            'Notification Earlier': '以前のもの',
            'Notification List': '通知リスト',
            'Bulk actions': '一括操作',
            'Notification Subject': '件名',
            'Notification Created Datetime': '作成日時',
            'Notification Message': '内容',
            'Notification Priority': '優先度',
            'Notification Status': 'ステータス',
            'Notification Mark As Read': '既読にする',
            'Notification Mark As Acknowledged': '確認',
            'Notification Low': '低',
            'Notification Medium': '中',
            'Notification High': '高',
            'Notification Critical': '重大',
            'Notification Unread': '未読',
            'Notification Read': '既読',
            'Notification Acknowledged': '確認済み',
            'Notification Archive': 'アーカイブ',
            'Notification Delete': '削除',
            'Notification Apply': '適用',
            'Notification Start Datetime': '開始日時',
            'Notification End Datetime': '終了日時',
            'Notification Update Datetime': '更新日時',
            //Monitoring
            'Run Commands': 'コマンド実行',
            'Pin Code': 'パスコード',
            'Unlock': 'ロック解除',
            'Set Value': '設定値',
            'Fault Alarms': '故障アラーム',
            'Instantaneous Efficiency VALUE UNIT': '瞬時効率 {{VALUE}} {{UNIT}}',
            'Communication Status': '通信ステータス',
            'Communication Online': 'オンライン',
            'Communication Offline': 'オフライン',
            'Equipment Status': '設備ステータス',
            'Equipment Running': '運転中',
            'Equipment Stopped': '停止中',
            'Show Up to': 'ページあたり表示数',
            All: 'すべて',
            'FROM - TO of TOTAL': '現在表示中 {{FROM}} - {{TO}} 合計{{TOTAL}}',
            //Microgrid
            'Microgrid Energy': '電力量',
            'Microgrid Revenue': '収益',
            'Microgrid Carbon': '炭素排出',
            'Photovoltaic Generation': '太陽光発電量',
            'EV Charger Consumption': '充電スタンド消費電力量',
            'Load Consumption': '負荷消費電力量',
            'Grid Buy': 'グリッドから購入電力量',
            'Grid Sell': 'グリッドへ販売電力量',
            'EV Charger': '充電スタンド',
            'Heat Pump': 'ヒートポンプ',
            'Photovoltaic': '太陽光発電',
            'PCS Run State': 'PCS運転状態',
            'PCS Unknown': '不明',
            'PCS Initializing': '初期起動',
            'PCS Standby': '待機中',
            'PCS Shutdown': '停止',
            'PCS Fault': '故障',
            'PCS Running': '運転中',
            'Battery Power': 'バッテリー電力',
            'Photovoltaic Power': '太陽光発電電力',
            'Grid Power': 'グリッド電力',
            'Load Power': '負荷電力',
            Reporting: 'データレポート',
            Maintenance: 'メンテナンス',
            'General Information': '基本情報',
            'Serial Number': 'シリアル番号',
            Address: '住所',
            'Postal Code': '郵便番号',
            'Rated Capacity': '定格容量',
            'Rated Power': '定格出力',
            Latitude: '緯度',
            Longitude: '経度',
            'Strategy Management': '戦略管理',
            'Charging Schedule': '充電スケジュール',
            'Charge Start Time': '充電開始時間',
            'Charge End Time': '充電終了時間',
            'Discharge Start Time': '放電開始時間',
            'Discharge End Time': '放電終了時間',
            'Total Rated Power': '総定格出力',
            'Total Rated Capacity': '総定格容量',
            // Energy Indicator
            "Today's Charge": "本日充電量",
            "Today's Discharge": "本日放電量",
            "Today's Generation": "本日発電量",
            'Total Fuel Consumption': '総燃料消費量',
            'Total Charge': '総充電量',
            'Total Discharge': '総放電量',
            'Total Generation': '総発電量',
            'Total Revenue': '総収益',
            'Total Photovoltaic Generation': '総太陽光発電量',
            'Total EV Charger Consumption': '充電スタンド総消費電力量',
            'Total Load Consumption': '負荷総消費電力量',
            'Total Grid Buy': 'グリッドから購入総電力量',
            'Total Grid Sell': 'グリッドへ販売総電力量',
            'Total Efficiency': '総合効率',
            'Discharge Achievement Rate': '放電達成率',
            // Revenue Indicator
            "Today's Cost": "本日コスト",
            "Today's Income": "本日収入",
            "Total Cost": "累積コスト",
            "Total Income": "累積収入",
            "Today's Revenue": "本日利益",
            
            'Revenue Ranking': '収益ランキング',
            'Efficiency Ranking': '効率ランキング',
            'Charge Ranking': '充電ランキング',
            'Discharge Ranking': '放電ランキング',
            'Number of Microgrids': 'マイクログリッド数',
            'Number of Power Stations': '発電所数',
            'Microgrid List': 'マイクログリッドリスト',
            'Select Microgrid': 'マイクログリッドを選択',
            'Previous Page': '前のページ',
            'Next Page': '次のページ',
            '7 Days': '7日間',
            'Charge UNIT': '充 {{UNIT}}',
            'Discharge UNIT': '放 {{UNIT}}',
            'Generation UNIT': '発電 {{UNIT}}',
            'Energy Indicator': 'エネルギー',
            'Revenue Indicator': '収益',
            'Carbon Indicator': '炭素',

            // Energy Storage Power Station
            'Battery Operating State': 'バッテリー運転状態',
            'Battery State': 'バッテリー状態',
            'Battery Unknown': '不明',
            'Battery Stopped': '停止',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': '故障', // 1
            'Battery Warning': '警告', // 2
            'Battery Standby': '待機中', // 3
            'Battery Prohibit DisCharging': '放電禁止', // 4
            'Battery Prohibit Charging': '充電禁止', // 5
            'Battery Normal': '正常', // 6
            'Battery Charging': '充電中', // 7
            'Battery Discharging': '放電中', // 8
            'Battery Idle': 'アイドル', // 9
            'Phase of Lifecycle': '段階',
            'Use Phase': '運用',
            'Commissioning Phase': '試運転',
            'Commissioning Date': '起動日',
            'Installation Phase': '建設中',
            'Device Status': 'デバイスステータス',
            'Basic Information': '基本情報',
            'Gateway': 'ゲートウェイ',
            'Grid Meter': 'グリッドメータ',
            'Load Meter': '負荷メータ',
            'ESS Meter': 'エネルギー貯蔵メータ',
            'Total Active Power': '総有効電力',
            'Active Power A': 'A相有効電力',
            'Active Power B': 'B相有効電力',
            'Active Power C': 'C相有効電力',
            'Total Reactive Power': '総無効電力',
            'Reactive Power A': 'A相無効電力',
            'Reactive Power B': 'B相無効電力',
            'Reactive Power C': 'C相無効電力',
            'Total Apparent Power': '総皮相電力',
            'Apparent Power A': 'A相皮相電力',
            'Apparent Power B': 'B相皮相電力',
            'Apparent Power C': 'C相皮相電力',
            'Total Power Factor': '総力率',
            'Active Energy Import': '正方向有効電力量',
            'Active Energy Export': '逆方向有効電力量',
            'Active Energy Net': '正味有効電力量',

            'Generator': '発電機',

            // Photovoltaic Power Station
            'Invertor': 'インバーター',
            'Invertor Run State': 'インバーター運転状態',
            'Invertor Unknown': '不明',
            'Invertor Initializing': '初期起動',
            'Invertor Standby': '待機中',
            'Invertor Shutdown': '停止',
            'Invertor Fault': '故障',
            'Invertor Running': '運転中',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': '生成日時',
            'File Format': 'ファイル形式',
            'File Size': 'ファイルサイズ',
            Uploader: 'アップロード者',
            'Upload Datetime': 'アップロード日時',
            //Error
            "The page you're looking for is not found": 'お探しのページは見つかりません',
            "Make sure the address is correct and that the page hasn't moved": 'アドレスが正しく、ページが移動していないことを確認してください',
            'If you think this is a mistake,': '間違いだと思われる場合は、',
            'contact us': 'お問い合わせください',
            'Take me home': 'ホームに戻る',
            'Whoops, something went wrong!': 'おっと、何か問題が発生しました！',
            'Try refreshing the page, or going back and attempting the action again':
                'ページを更新するか、戻って再度操作を試みてください',
            'If this problem persists,': 'この問題が続く場合は、',
            'Captcha Error': '認証コードエラー',
            'Confirm Password Error': 'パスワードが一致しません',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                '無効なパスワードリセットリンクをクリックしたようです。もう一度お試しください。',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                '無効なアカウント登録リンクをクリックしたようです。もう一度お試しください。',
            //Tenant Bill
            'Lease Contract Number': '賃貸契約番号',
            Download: 'ダウンロード',
            Print: '印刷',
            'Payment Notice': '支払通知書',
            'Bill To': '宛先',
            'Bill Number': '請求書番号',
            'Bill Date': '請求書日付',
            'Payment Due Date': '支払期日',
            'Amount Payable': '支払金額',
            'Billing Period Start': '請求期間開始日',
            'Billing Period End': '請求期間終了日',
            Quantity: '数量',
            Price: '単価',
            Unit: '単位',
            Amount: '金額',
            Subtotal: '小計',
            'VAT Output Tax': '消費税（売上税）',
            'Total Amount Payable': '支払総額',
            'Please make sure to pay on or before the payment due date above': '上記の支払期日までにお支払いください',
            'Send money to the following account': '次の口座へお振り込みください',
            'Account Name': '口座名義',
            'Bank Name': '銀行名',
            'Bank Address': '銀行住所',
            'RMB Account': '人民元口座',
            // button
            'Toggle Navigation': 'ナビゲーション切り替え',
            // working calendar
            'Working Days': '営業日',
            'Non Working Days': '非営業日',
            'Select Row': '操作するデータ行を選択してください',
            // Offline Meter Input
            'Daily Value': '日次データ',
            Date: '日付',
            'Successfully Saved': '保存成功',
            'Previous Data Is Empty': '以前のデータが空です',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': '管理者セッションが存在しません',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': '管理者セッションがタイムアウトしました',
            'API.ADVANCED_REPORT_NOT_FOUND': '高度レポートが存在しません',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': '不正なリクエスト',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': '既にサブメータとして設定されている計量メータを総メータに設定できません',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': '複合設備コマンド関係が存在します',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': '複合設備と設備の関係が既に存在します',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': '複合設備と設備の関係が存在しません',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': '複合設備と計量メータの関係が既に存在します',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': '複合設備と計量メータの関係が存在しません',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': '複合設備名称が既に使用されています',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': '複合設備が存在しません',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '複合設備とオフラインメータの関係が既に存在します',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '複合設備とオフラインメータの関係が存在しません',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '複合設備関連パラメータ名称が既に使用されています',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '複合設備関連パラメータが存在しないか、一致しません',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '複合設備と仮想メータの関係が既に存在します',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '複合設備と仮想メータの関係が存在しません',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': '連絡先名が既に使用されています',
            'API.CONTACT_NOT_FOUND': '連絡先が存在しません',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'コストセンター外部IDが既に存在します',
            'API.COST_CENTER_NAME_EXISTS': 'コストセンター名称が既に存在します',
            'API.COST_CENTER_NOT_FOUND': 'コストセンターが存在しません',
            'API.COST_FILE_NOT_FOUND': 'コストファイルが存在しません',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'データソース名称が既に使用されています',
            'API.DATA_SOURCE_NOT_FOUND': 'データソースが存在しません',
            'API.DATABASE_ERROR': 'データベースエラー',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': '日付が既に営業日カレンダーに存在します',
            'API.DATE_LOCAL_NOT_FOUND': 'ローカル日付が見つかりません',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': '配電回路名称が既に使用されています',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': '配電回路が存在しません',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': '配電回路とデータポイントの関係が既に存在します',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': '配電回路とデータポイントの関係が存在しません',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': '配電システム名称が既に使用されています',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': '配電システムが存在しません',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': '電子メールアドレスが既に使用されています',
            'API.EMAIL_MESSAGE_NOT_FOUND': '電子メールメッセージが存在しません',
            'API.EMAIL_NOT_FOUND': '電子メールアドレスが存在しません',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'メールサーバーホストが既に使用されています',
            'API.EMAIL_SERVER_NOT_FOUND': 'メールサーバーホストが存在しません',
            'API.EMPTY_VARIABLES_ARRAY': '空の変数配列',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'エネルギー分類名称が既に使用されています',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'エネルギー分類が存在しません',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'エネルギー分類がエネルギー項目で既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'エネルギー分類が計量メータで既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'エネルギー分類がオフラインメータで既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'エネルギー分類が料率で既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'エネルギー分類が仮想メータで既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'エネルギー流れ図リンクが既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'エネルギー流れ図リンクが存在しないか、一致しません',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'エネルギー流れ図名称が既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'エネルギー流れ図ノードが既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'エネルギー流れ図ノードが存在しないか、一致しません',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'エネルギー流れ図が存在しません',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'エネルギー項目はエネルギー分類に属していません',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'エネルギー項目はエネルギー分類に属していません',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'エネルギー項目が既に使用されています',
            'API.ENERGY_ITEM_NOT_FOUND': 'エネルギー項目が存在しません',
            'API.ENERGY_ITEM_USED_IN_METER': 'エネルギー項目が計量メータで既に使用されています',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'エネルギー項目がオフラインメータで既に使用されています',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'エネルギー項目が仮想メータで既に使用されています',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': '設備と計量メータの関係が既に存在します',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': '設備と計量メータの関係が存在しません',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': '設備名称が既に使用されています',
            'API.EQUIPMENT_NOT_FOUND': '設備が存在しません',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '設備とオフラインメータの関係が既に存在します',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '設備とオフラインメータの関係が存在しません',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '設備関連パラメータ名称が既に使用されています',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '設備関連パラメータが存在しないか、一致しません',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '設備と仮想メータの関係が既に存在します',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '設備と仮想メータの関係が存在しません',
            'API.ERROR': 'エラー',
            'API.EXCEPTION': '例外',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'コストファイルの復元に失敗しました',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'ナレッジファイルの復元に失敗しました',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'オフラインメータファイルの復元に失敗しました',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'オフラインメータファイルの保存に失敗しました',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'コストファイルのアップロードに失敗しました',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'ナレッジファイルのアップロードに失敗しました',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'オフラインメータファイルのアップロードに失敗しました',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'ゲートウェイ名称が既に使用されています',
            'API.GATEWAY_NOT_FOUND': 'ゲートウェイが存在しません',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': '無効な ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': '無効なアドレス',
            'API.INVALID_ADDRESS_VALUE': '無効なアドレス値',
            'API.INVALID_ADVANCED_REPORT_ID': '無効な高度レポートID',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': '無効な面積値',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': '無効な基準期間終了日時',
            'API.INVALID_BASE_PERIOD_START_DATETIME': '無効な基準期間開始日時',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': '無効なボーレート',
            'API.INVALID_BUILDINGS_VALUE': '無効な建物値',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': '無効なカテゴリー',
            'API.INVALID_CHANNEL': '無効なチャネル',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': '無効な複合設備ID',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': '無効な複合設備名称',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': '無効な複合設備関連パラメータID',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': '無効な複合設備関連パラメータ名称',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': '無効な複合設備関連パラメータタイプ',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': '無効な複合設備UUIDs',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': '無効な接続',
            'API.INVALID_CONSTANT_VALUE': '無効な定数値',
            'API.INVALID_CONTACT_ID': '無効な連絡先ID',
            'API.INVALID_CONTACT_NAME': '無効な連絡先名',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': '無効なコストセンターID',
            'API.INVALID_COST_FILE_ID': '無効なコストファイルID',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': '無効なデータソースID',
            'API.INVALID_DATA_SOURCE_NAME': '無効なデータソース名称',
            'API.INVALID_DATA_SOURCE_PROTOCOL': '無効なデータソースプロトコル',
            'API.INVALID_DATE_LOCAL': '無効なローカル日付',
            'API.INVALID_DENOMINATOR_METER_UUID': '無効な基準計量メータUUID',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': '無効な表示名',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': '無効な配電回路ID',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': '無効な配電回路名称',
            'API.INVALID_DISTRIBUTION_ROOM': '無効な配電室',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': '無効な配電システムID',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': '無効な配電システム名称',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': '無効なメールアドレス',
            'API.INVALID_EMAIL_MESSAGE_ID': '無効な電子メールID',
            'API.INVALID_EMAIL_SERVER_HOST': '無効な電子メールサーバーホスト',
            'API.INVALID_EMAIL_SERVER_ID': '無効な電子メールサーバーID',
            'API.INVALID_END_DATE_FORMAT': '無効な終了日付形式',
            'API.INVALID_END_DATETIME': '無効な終了日時',
            'API.INVALID_ENERGY_CATEGORY_ID': '無効なエネルギー分類ID',
            'API.INVALID_ENERGY_CATEGORY_NAME': '無効なエネルギー分類名称',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': '無効なエネルギー流れ図ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': '無効なエネルギー流れ図リンクID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': '無効なエネルギー流れ図名称',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': '無効なエネルギー流れ図ノードID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': '無効なエネルギー流れ図ノード名称',
            'API.INVALID_ENERGY_ITEM_ID': '無効なエネルギー項目ID',
            'API.INVALID_ENERGY_ITEM_NAME': '無効なエネルギー項目名称',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': '式内の無効な方程式',
            'API.INVALID_EQUIPMENT_ID': '無効な設備ID',
            'API.INVALID_EQUIPMENT_NAME': '無効な設備名称',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': '無効な設備関連パラメータID',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': '無効な設備関連パラメータ名称',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': '無効な設備関連パラメータタイプ',
            'API.INVALID_EQUIPMENT_UUID': '無効な設備UUID',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': '無効な式',
            'API.INVALID_EXPRESSION_OBJECT': '無効な式オブジェクト',
            'API.INVALID_FDD_CODE': '無効な故障エラーコード',
            'API.INVALID_FLOORS_VALUE': '無効な階数値',
            'API.INVALID_FROM_ADDR': '無効なアドレス',
            'API.INVALID_GATEWAY_ID': '無効なゲートウェイID',
            'API.INVALID_GATEWAY_NAME': '無効なゲートウェイ名称',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': '無効な時間上限値',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': '無効な時間下限値',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': '無効な管理値',
            'API.INVALID_IS_COST_DATA_DISPLAYED': '無効なコストデータ表示フラグ',
            'API.INVALID_IS_COUNTED_VALUE': '無効な計上値',
            'API.INVALID_IS_ENABLED': '無効な有効化フラグ',
            'API.INVALID_IS_HIDDEN': '無効な非表示フラグ',
            'API.INVALID_IS_IN_LEASE_VALUE': '無効な賃貸中フラグ',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': '無効な入力計上フラグ',
            'API.INVALID_IS_KEY_TENANT_VALUE': '無効な主力テナントフラグ',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': '無効な出力計上フラグ',
            'API.INVALID_IS_OUTPUT_VALUE': '無効な出力計上フラグ',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': '無効な傾向保存フラグ',
            'API.INVALID_IS_VIRTUAL_VALUE': '無効な仮想ポイントフラグ',
            'API.INVALID_KGCE': '無効なキログラム標準炭係数',
            'API.INVALID_KGCO2E': '無効なキログラム二酸化炭素排出係数',
            'API.INVALID_KNOWLEDGE_FILE_ID': '無効なナレッジファイルID',
            'API.INVALID_LATITUDE_VALUE': '無効な緯度値',
            'API.INVALID_LEASE_NUMBER_VALUE': '無効なリース番号',
            'API.INVALID_LONGITUDE_VALUE': '無効な経度値',
            'API.INVALID_LOW_LIMIT_VALUE': '無効な下限値',
            'API.INVALID_MASTER_METER_ID': '無効な総計量メータID',
            'API.INVALID_MENU_ID': '無効なメニューID',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': '無効なメッセージテンプレート',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': '無効な計量メータID',
            'API.INVALID_METER_NAME': '無効な計量メータ名称',
            'API.INVALID_METER_UUID': '無効な計量メータUUID',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': '無効な名称値',
            'API.INVALID_NEW_PASSWORD': '無効な新パスワード',
            'API.INVALID_NON_WORKING_DAY_ID': '無効な非営業日ID',
            'API.INVALID_NOTIFICATION_ID': '無効な通知ID',
            'API.INVALID_NUMERATOR_METER_UUID': '無効な分子メータUUID',
            'API.INVALID_OBJECT_TYPE': '無効なオブジェクトタイプ',
            'API.INVALID_OFFLINE_METER_DATA': '無効なオフラインメータデータ',
            'API.INVALID_OFFLINE_METER_FILE_ID': '無効なオフラインメータファイルID',
            'API.INVALID_OFFLINE_METER_ID': '無効なオフラインメータID',
            'API.INVALID_OFFLINE_METER_NAME': '無効なオフラインメータ名称',
            'API.INVALID_OFFLINE_METER_UUID': '無効なオフラインメータUUID',
            'API.INVALID_OFFSET_CONSTANT_VALUE': '無効なオフセット定数',
            'API.INVALID_OLD_PASSWORD': '無効な旧パスワード',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': '無効な親空間ID',
            'API.INVALID_PASSWORD': '無効なパスワード',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': '無効なピーク電流',
            'API.INVALID_PEAK_LOAD': '無効なピーク負荷',
            'API.INVALID_PERIOD_TYPE': '無効な期間タイプ',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': '無効なデータポイントID',
            'API.INVALID_POINT_NAME': '無効なデータポイント名称',
            'API.INVALID_PORT': '無効なポート',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': '無効な優先度',
            'API.INVALID_PRIVILEGE': '無効な権限',
            'API.INVALID_PRIVILEGE_DATA': '無効な権限データ',
            'API.INVALID_PRIVILEGE_ID': '無効な権限ID',
            'API.INVALID_PRIVILEGE_NAME': '無効な権限名称',
            'API.INVALID_RATIO_VALUE': '無効な変圧比',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': '無効な返信',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': '無効な報告期間終了日時',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': '無効な報告期間開始日時',
            'API.INVALID_REQUIRES_AUTHENTICATION': '無効な認証必要フラグ',
            'API.INVALID_ROOMS_VALUE': '無効な部屋数値',
            'API.INVALID_RULE_ID': '無効なルールID',
            'API.INVALID_RULE_NAME': '無効なルール名称',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': '無効なセンサーID',
            'API.INVALID_SENSOR_NAME': '無効なセンサー名称',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': '無効なシリアルポート',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'セッションが無効です、再ログインしてください',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': '無効な現場ID',
            'API.INVALID_SHOPFLOOR_NAME': '無効な現場名称',
            'API.INVALID_SHOPFLOOR_UUID': '無効な現場UUID',
            'API.INVALID_SOURCE_NODE_ID': '無効なソースノードID',
            'API.INVALID_SPACE_ID': '無効な空間ID',
            'API.INVALID_SPACE_NAME': '無効な空間名称',
            'API.INVALID_SPACE_UUID': '無効な空間UUID',
            'API.INVALID_START_DATE_FORMAT': '無効な開始日付形式',
            'API.INVALID_START_DATETIME': '無効な開始日時',
            'API.INVALID_STATUS': '無効なステータス',
            'API.INVALID_STORE_ID': '無効な店舗ID',
            'API.INVALID_STORE_NAME': '無効な店舗名称',
            'API.INVALID_STORE_TYPE_DESCRIPTION': '無効な店舗タイプ説明',
            'API.INVALID_STORE_TYPE_ID': '無効な店舗タイプID',
            'API.INVALID_STORE_TYPE_NAME': '無効な店舗タイプ名称',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': '無効な店舗タイプ簡略コード',
            'API.INVALID_STORE_UUID': '無効な店舗UUID',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': '無効なSVG',
            'API.INVALID_SWITCHGEAR': '無効な開閉装置',
            'API.INVALID_TARGET_NODE_ID': '無効なターゲットノードID',
            'API.INVALID_TARIFF_BLOCK_PRICING': '無効な段階料率価格設定',
            'API.INVALID_TARIFF_ID': '無効な料率ID',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': '無効な時間帯別料率価格設定',
            'API.INVALID_TARIFF_TYPE': '無効な料率タイプ',
            'API.INVALID_TENANT_ID': '無効なテナントID',
            'API.INVALID_TENANT_NAME': '無効なテナント名称',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': '無効なテナントタイプ説明',
            'API.INVALID_TENANT_TYPE_ID': '無効なテナントタイプID',
            'API.INVALID_TENANT_TYPE_NAME': '無効なテナントタイプ名称',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': '無効なテナントタイプ簡略コード',
            'API.INVALID_TENANT_UUID': '無効なテナントUUID',
            'API.INVALID_TEXT_MESSAGE_ID': '無効なSMS ID',
            'API.INVALID_TIMEZONE_ID': '無効なタイムゾーンID',
            'API.INVALID_TOKEN': '無効なトークン',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': '無効な測定単位',
            'API.INVALID_UNIT_OF_PRICE': '無効な価格単位',
            'API.INVALID_UNITS': '無効な単位',
            'API.INVALID_USER_ID': '無効なユーザーID',
            'API.INVALID_USER_NAME': '無効なユーザー名称',
            'API.INVALID_USER_NAME_OR_EMAIL': '無効なユーザー名称またはメールアドレス',
            'API.INVALID_USER_PHONE': '無効なユーザー電話番号',
            'API.INVALID_USER_PLEASE_RE_LOGIN': '無効なユーザー、再ログインしてください',
            'API.INVALID_USER_UUID': '無効なユーザーUUID',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': '無効な変数計量メータID',
            'API.INVALID_VARIABLE_METER_TYPE': '無効な変数計量メータタイプ',
            'API.INVALID_VARIABLE_NAME': '無効な変数名称',
            'API.INVALID_VERIFICATION_CODE': '無効な認証コード',
            'API.INVALID_VIRTUAL_METER_ID': '無効な仮想メータID',
            'API.INVALID_VIRTUAL_METER_NAME': '無効な仮想メータ名称',
            'API.INVALID_VIRTUAL_METER_UUID': '無効な仮想メータUUID',
            'API.INVALID_WEB_MESSAGE_ID': '無効なWebメッセージID',
            'API.INVALID_WECHAT_MESSAGE_ID': '無効なWeChatメッセージID',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': '無効な営業日カレンダーID',
            'API.INVALID_WORKING_CALENDAR_NAME': '無効な営業日カレンダー名称',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'ナレッジファイルをディスクから削除できません',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'ナレッジファイルが存在しません',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': '総メータは同じエネルギー分類に属していません',
            'API.MASTER_METER_NOT_FOUND': '総メータが存在しません',
            'API.MENU_NOT_FOUND': 'メニューが存在しません',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': '計量メータ名称が既に使用されています',
            'API.METER_NOT_FOUND': '計量メータが存在しません',
            'API.METER_OF_VARIABLE_NOT_FOUND': '変数の計量メータが存在しません',
            'API.METER_POINT_RELATION_EXISTS': '計量メータとデータポイントの関係が既に存在します',
            'API.METER_POINT_RELATION_NOT_FOUND': '計量メータとデータポイントの関係が存在しません',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '新パスワードの長さは100文字を超えることはできません',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': '非営業日が存在しません',
            'API.NOT_FOUND': '存在しません',
            'API.NOTIFICATION_NOT_FOUND': '通知が存在しません',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'オフラインメータファイルが存在しません',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'オフラインメータ名称が既に使用されています',
            'API.OFFLINE_METER_NOT_FOUND': 'オフラインメータが存在しません',
            'API.INVALID_OFFLINE_METER_VALUE': '無効なオフラインメータ値',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': '変数のオフラインメータが存在しません',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '旧パスワードの長さは100文字を超えることはできません',
            'API.PARENT_SPACE_NOT_FOUND': '親空間が存在しません',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'パスワードの長さは100文字を超えることはできません',
            'API.PASSWORDS_MATCH': '新パスワードが旧パスワードと一致しています',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'データポイント名称が既に使用されています',
            'API.POINT_NOT_FOUND': 'データポイントが存在しません',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': '権限名称が既に使用されています',
            'API.PRIVILEGE_NOT_FOUND': '権限が存在しません',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'ルール名称が既に使用されています',
            'API.RULE_NOT_FOUND': 'ルールが存在しません',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'センサー名称が既に使用されています',
            'API.SENSOR_NOT_FOUND': 'センサーが存在しません',
            'API.SENSOR_POINT_RELATION_EXISTS': 'センサーとデータポイントの関係が既に存在します',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'センサーとデータポイントの関係が存在しません',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': '現場と設備の関係が既に存在します',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': '現場と設備の関係が存在しません',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': '現場と計量メータの関係が既に存在します',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': '現場と計量メータの関係が存在しません',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': '現場名称が既に使用されています',
            'API.SHOPFLOOR_NOT_FOUND': '現場が存在しません',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': '現場とオフラインメータの関係が既に存在します',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': '現場とオフラインメータの関係が存在しません',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': '現場とデータポイントの関係が既に存在します',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': '現場とデータポイントの関係が存在しません',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': '現場とセンサーの関係が既に存在します',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': '現場とセンサーの関係が存在しません',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': '現場と仮想メータの関係が既に存在します',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': '現場と仮想メータの関係が存在しません',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': '現場営業日カレンダー関係が既に存在します',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': '現場と営業日カレンダーの関係が存在しません',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'ソースノードが存在しません',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': '空間と複合設備の関係が既に存在します',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': '空間と複合設備の関係が存在しません',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': '空間と設備の関係が既に存在します',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': '空間と設備の関係が存在しません',
            'API.SPACE_METER_RELATION_EXISTS': '空間と計量メータの関係が既に存在します',
            'API.SPACE_METER_RELATION_NOT_FOUND': '空間と計量メータの関係が存在しません',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': '空間名称が既に使用されています',
            'API.SPACE_NOT_FOUND': '空間が存在しません',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': '権限内に空間が存在しません',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': '空間とオフラインメータの関係が既に存在します',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': '空間とオフラインメータの関係が存在しません',
            'API.SPACE_POINT_RELATION_EXISTS': '空間とデータポイントの関係が既に存在します',
            'API.SPACE_POINT_RELATION_NOT_FOUND': '空間とデータポイントの関係が存在しません',
            'API.SPACE_SENSOR_RELATION_EXISTS': '空間とセンサーの関係が既に存在します',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': '空間とセンサーの関係が存在しません',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': '空間と現場の関係が既に存在します',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': '空間と現場の関係が存在しません',
            'API.SPACE_STORE_RELATION_EXISTS': '空間と店舗の関係が既に存在します',
            'API.SPACE_STORE_RELATION_NOT_FOUND': '空間と店舗の関係が存在しません',
            'API.SPACE_TENANT_RELATION_EXISTS': '空間とテナントの関係が既に存在します',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': '空間とテナントの関係が存在しません',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': '空間と仮想メータの関係が既に存在します',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': '空間と仮想メータの関係が存在しません',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': '空間と営業日カレンダーの関係が既に存在します',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': '空間と営業日カレンダーの関係が存在しません',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': '開始日時は終了日時より前でなければなりません',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': '店舗と計量メータの関係が既に存在します',
            'API.STORE_METER_RELATION_NOT_FOUND': '店舗と計量メータの関係が存在しません',
            'API.STORE_NAME_IS_ALREADY_IN_USE': '店舗名称が既に使用されています',
            'API.STORE_NOT_FOUND': '店舗が存在しません',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': '店舗とオフラインメータの関係が既に存在します',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': '店舗とオフラインメータの関係が存在しません',
            'API.STORE_POINT_RELATION_EXISTS': '店舗とデータポイントの関係が既に存在します',
            'API.STORE_POINT_RELATION_NOT_FOUND': '店舗とデータポイントの関係が存在しません',
            'API.STORE_SENSOR_RELATION_EXISTS': '店舗とセンサーの関係が既に存在します',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': '店舗とセンサーの関係が存在しません',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': '店舗タイプ名称が既に使用されています',
            'API.STORE_TYPE_NOT_FOUND': '店舗タイプが存在しません',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '店舗タイプ簡略コードが既に使用されています',
            'API.STORE_TYPE_USED_IN_STORE': '店舗タイプが店舗で既に使用されています',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': '店舗と仮想メータの関係が既に存在します',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': '店舗と仮想メータの関係が存在しません',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': '店舗と営業日カレンダーの関係が既に存在します',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': '店舗と営業日カレンダーの関係が存在しません',
            'API.TARGET_NODE_NOT_FOUND': 'ターゲットノードが存在しません',
            'API.TARIFF_IN_USE': '料率は使用中です',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': '料率とコストセンターは既に関連付けられています',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': '料率とコストセンターは関連付けられていません',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': '料率名称が既に使用されています',
            'API.TARIFF_NOT_FOUND': '料率が存在しません',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'テナントと計量メータの関係が既に存在します',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'テナントと計量メータの関係が存在しません',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'テナント名称が既に使用されています',
            'API.TENANT_NOT_FOUND': 'テナントが存在しません',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'テナントとオフラインメータの関係が既に存在します',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'テナントとオフラインメータの関係が存在しません',
            'API.TENANT_POINT_RELATION_EXISTS': 'テナントとデータポイントの関係が既に存在します',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'テナントとデータポイントの関係が存在しません',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'テナントとセンサーの関係が既に存在します',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'テナントとセンサーの関係が存在しません',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'テナントとタイプ名称が既に使用されています',
            'API.TENANT_TYPE_NOT_FOUND': 'テナントタイプが存在しません',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'テナントタイプ簡略コードが既に使用されています',
            'API.TENANT_TYPE_USED_IN_TENANT': 'テナントタイプがテナントで既に使用されています',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'テナントと仮想メータの関係が既に存在します',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'テナントと仮想メータの関係が存在しません',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'テナントと営業日カレンダーの関係が既に存在します',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'テナントと営業日カレンダーの関係が存在しません',
            'API.TEXT_MESSAGE_NOT_FOUND': 'SMSが見つかりません',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': '報告期間は15分より長くなければなりません',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': '子メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': '子空間との関係があります',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': '複合設備関連パラメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': '複合設備との関係があります',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'データソースとの関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'エネルギー流れ図との関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'エネルギー貯蔵コンテナバッテリーとの関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'エネルギー貯蔵コンテナグリッドとの関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'エネルギー貯蔵コンテナ負荷との関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'エネルギー貯蔵コンテナPCSとの関係があります',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': '設備関連パラメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': '設備との関係があります',
            'API.THERE_IS_RELATION_WITH_METER': '計量メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_METERS': '複数の計量メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'オフラインメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': '複数のオフラインメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': '仮想メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'センサーとの関係があります',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': '現場との関係があります',
            'API.THERE_IS_RELATION_WITH_SPACES': '空間との関係があります',
            'API.THERE_IS_RELATION_WITH_STORES': '店舗との関係があります',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'テナントとの関係があります',
            'API.THERE_IS_RELATION_WITH_USERS': 'ユーザーとの関係があります',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': '仮想メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': '仮想発電所との関係があります',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'このデータソースは計量メータで使用中です',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'この計量メータは仮想メータで使用中です',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'このオフラインメータは仮想メータで使用中です',
            'API.THIS_SPACE_CANNOT_BE_CLONED': '空間は複製できません',
            'API.THIS_SPACE_CANNOT_BE_DELETED': '空間は削除できません',
            'API.TIMEZONE_NOT_FOUND': 'タイムゾーンが存在しません',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'トークンが見つかりません、ログインしてください',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'ユーザーアカウントがロックされました',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'ユーザーアカウントの有効期限が切れています',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'ユーザー名が既に使用されています',
            'API.USER_NOT_FOUND': 'ユーザーが存在しません',
            'API.USER_PASSWORD_HAS_EXPIRED': 'ユーザーパスワードの有効期限が切れています',
            'API.USER_PRIVILEGE_NOT_FOUND': 'ユーザー権限が見つかりません',
            'API.USER_SESSION_NOT_FOUND': 'ユーザーセッションが見つかりません',
            'API.USER_SESSION_TIMEOUT': 'ユーザーセッションがタイムアウトしました',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'ユーザーUUIDが存在しません、ログインしてください',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': '仮想メータ名称が既に使用されています',
            'API.VIRTUAL_METER_NOT_FOUND': '仮想メータが存在しません',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': '変数の仮想メータが存在しません',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': '仮想データポイントはアナログ値である必要があります',
            'API.WEB_MESSAGE_NOT_FOUND': 'Webメッセージが存在しません',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'WeChatメッセージが存在しません',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': '営業日カレンダー名称が既に使用されています',
            'API.WORKING_CALENDAR_NOT_FOUND': '営業日カレンダーが存在しません',

            MasterMeter: '総メータ',
            SubMeter: 'サブメータ',
            'Power Quality': '電力量質',
            'About Power Quality': '電力量質について',
            Category: 'カテゴリー',
            Type: 'タイプ',
            Limit: '限界値',
            'Normal Limit': '正常限界値',
            'Severe Limit': '重大限界値',
            Compliance: 'コンプライアンス率',
            'Worst Deviation': '最悪偏差',
            'Worst Time': '最悪発生時刻',
            'Severe Exceed Count': '重大越限回数',
            'Worst Unbalance': '最大不平衡率',
            Hz: 'ヘルツ',
            voltage: '電圧',
            current: '電流',
            frequency: '周波数',
            voltage_deviation: '電圧偏差',
            current_unbalance: '電流不平衡',
            voltage_unbalance: '電圧不平衡',
            mean_deviation_pct: '平均偏差(%)',
            p95_abs_deviation_pct: 'P95絶対偏差(%)',
            mean_abs_deviation_hz: '平均絶対偏差(Hz)',
            frequency_deviation: '周波数偏差',
            p95_abs_deviation_hz: 'P95絶対偏差(Hz)',
            mean_unbalance_pct: '平均不平衡率(%)',
            p95_unbalance_pct: 'P95不平衡率(%)',
            count: 'カウント',
            min: '最小値',
            max: '最大値',
            mean: '平均値',
            std: '標準偏差',
            p5: 'P5',
            p95: 'P95'
        }
};
